import { putApi } from '../../../utils/api'

export function updateSearchResultsBuildingsTableConfig(data) {
  return putApi({
    data,
    endpoint: 'idwell-api/api/v3/table/tables/buildings-search/config/',
  })
}
